import React from 'react'
import { TextTitle, TextCaption } from '@pmi/pmi-iqos-ds-react'
import { formatDate } from '@pmi/pmi-iqos-shared-react'

const HeaderNotice = ({ date, name }) => {
  return (
    <>
      <TextCaption>{formatDate(date.slice(0, 10))}</TextCaption>
      <TextTitle heading={TextTitle.headings.h6}>{name}</TextTitle>
    </>
  )
}

export default HeaderNotice
